export default "__VITE_ASSET__CAHktb2t__"